import {gsap} from 'gsap';

export default function customVimeo(element){
  const parent = element;

  if (!parent.querySelector('iframe')) {
    return
  }

  const overlay = parent.querySelector('.video-overlay');
  const iframe = parent.querySelector('iframe');
  const player = new Vimeo.Player(iframe);
  const playButton = parent.querySelector('button');

  overlay.addEventListener('click', (e) => {
    console.log('play click')
    overlay.classList.toggle('playing');

    if(overlay.classList.contains('playing')){
      gsap.to(playButton, {alpha: 0})
      player.play();
    }else{
      gsap.to(playButton, {alpha: 1})
      player.pause();
    }
  });
}